// Carry Roll CSV export — native CSV serializer (11.5).

import type { ShotRecord, Session } from '@carry-roll/shared-types';

export function shotsToCsv(shots: ShotRecord[]): string {
  const header = [
    'id',
    'ballSpeed_ms',
    'launchAngle_deg',
    'spinRpm',
    'carryM',
    'totalM',
    'excluded',
  ];
  const rows = shots.map((s) => [
    s.id,
    s.request.launch.ballSpeed.toFixed(2),
    ((s.request.launch.launchAngle * 180) / Math.PI).toFixed(2),
    Math.round(s.request.launch.spinRpm),
    s.carryM.toFixed(1),
    s.totalM.toFixed(1),
    s.excluded,
  ]);
  return [header.join(','), ...rows.map((r) => r.join(','))].join('\n');
}

export function sessionToCsv(session: Session): string {
  return shotsToCsv(session.shots);
}

export function downloadCsv(filename: string, csv: string): void {
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
